import Quote from "@system/config/quote";
import React, { useEffect, useState } from 'react';
import ShowAlert from "src/component/Global/ShowAlert"
import liveAuth from 'src/helper/liveAuth';
import System from 'src/helper/system';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import ReusableDiv from "src/helper/ReusableDiv"
import { __remove, __set } from 'src/store/axios_indicator';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { useQuoteStore } from "src/hooks/quote";

const AddressDetails = {
    companyName: '',
    addressLineOne: '',
    addressLineTwo: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    attn: ''
}

export const AddressForm = ({ countryList, from, handleChange, renderStateListOnCountryChange, stateList, invoiceDetail, shippingDetail, errors, countriesHasData }) => {
    const { shippingDetailError, invoiceDetailError } = errors
    const countryCode = from === 'shipping' ? shippingDetail.country : invoiceDetail?.country
    return (
        <div className=" bs5 row">
            <div className='col-9'>
                <div className=" bs5 row">
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor={`companyName${from}`} className='d-block'>Company Name*</label>
                            <input type="text" className="form-control form-control-sm" id={`companyName${from}`} name={`companyName${from}`} placeholder="Company Name"
                                value={from === 'shipping' ? shippingDetail.companyName : invoiceDetail?.companyName}
                                onChange={({ target: { value } }) => handleChange('companyName', value, from)}
                                maxLength={35}
                            />
                            <p className="error">{from === 'shipping' ? shippingDetailError?.companyName : invoiceDetailError?.companyName}</p>
                        </div>
                    </div>
                </div>
                <div className=" bs5 row">
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor={`addressLineOne-${from}`} className='d-block'>Address 1*</label>
                            <input type="text" className="form-control form-control-sm" id={`addressLineOne-${from}`} placeholder="Address 1"
                                value={from === 'shipping' ? shippingDetail.addressLineOne : invoiceDetail?.addressLineOne}
                                onChange={({ target: { value } }) => handleChange('addressLineOne', value, from)} maxLength={35}
                            />
                            <p className="error">{from === 'shipping' ? shippingDetailError?.addressLineOne : invoiceDetailError?.addressLineOne}</p>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor={`addressLineTwo-${from}`} className='d-block'>Address 2</label>
                            <input type="text" className="form-control form-control-sm" id={`addressLineTwo-${from}`} placeholder="Address 2"
                                value={from === 'shipping' ? shippingDetailError?.addressLineTwo : invoiceDetail?.addressLineTwo}
                                onChange={({ target: { value } }) => handleChange('addressLineTwo', value, from)} maxLength={35}
                            />
                        </div>
                    </div>
                </div>
                <div className=" bs5 row">
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor={`city-${from}`} className='d-block'>City*</label>
                            <input type="text" className="form-control form-control-sm" id={`city-${from}`} placeholder="City"
                                value={from === 'shipping' ? shippingDetail.city : invoiceDetail?.city}
                                onChange={({ target: { value } }) => handleChange('city', value, from)}
                                maxLength={35}
                            />
                            <p className="error">{from === 'shipping' ? shippingDetailError?.city : invoiceDetailError?.city}</p>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor={`country-${from}`} className='d-block'>Country*</label>
                            <div className="selectbox">
                                <select className="form-control form-control-sm" id={`country-${from}`}
                                    value={from === 'shipping' ? shippingDetail.country : invoiceDetail?.country}
                                    onChange={({ target: { value } }) => { renderStateListOnCountryChange(value, from); handleChange('country', value, from); }}
                                >
                                    <option value="">- Please Select -</option>
                                    {countryList && countryList.map((v, i) => (
                                        <option key={v.countryId} value={v.countryCode} >{v.countryName} </option>
                                    ))}
                                </select>
                            </div>
                            <p className="error">{from === 'shipping' ? shippingDetailError?.country : invoiceDetailError?.country}</p>
                        </div>
                    </div>
                </div>
                <div className=" bs5 row">
                    <div className="col-6">
                        <div className=" bs5 row">
                            <div className="col-6"><div className="form-group">
                                <label htmlFor={`state-${from}`} className='d-block'>State/Province{countriesHasData.includes(countryCode) && '*'}</label>
                                {countriesHasData.includes(countryCode) ? (
                                    <div className="selectbox">
                                        <select className="form-control form-control-sm" id={`state-${from}`}
                                            value={from === 'shipping' ? shippingDetail.state : invoiceDetail?.state}
                                            onChange={({ target: { value } }) => handleChange('state', value, from)}
                                        >
                                            <option value="">- Please Select -</option>
                                            {from === 'shipping' ? (
                                                stateList?.shippingStateList?.length > 0 && stateList?.shippingStateList.map(obj => (
                                                    <option key={obj.stateId} value={obj.stateCode}>{obj.stateName}</option>
                                                ))
                                            ) : (
                                                stateList?.invoiceStateList?.length > 0 && stateList?.invoiceStateList.map(obj => (
                                                    <option key={obj.stateId} value={obj.stateCode}>{obj.stateName}</option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                ) : (
                                    <input type="text" className="form-control form-control-sm" id={`state-${from}`} placeholder="State/Province"
                                        value={from === 'shipping' ? shippingDetail.state : invoiceDetail?.state}
                                        onChange={({ target: { value } }) => handleChange('state', value, from)}
                                    />
                                )}

                                <p className="error">{from === 'shipping' ? shippingDetailError?.state : invoiceDetailError?.state}</p>
                            </div></div>
                            <div className="col-6"><div className="form-group">
                                <label htmlFor={`postalCode-${from}`} className='d-block'>Zip/Postal Code*</label>
                                <input type="text" className="form-control form-control-sm" id={`postalCode-${from}`} placeholder="Zip/Postal Code"
                                    value={from === 'shipping' ? shippingDetail.postalCode : invoiceDetail?.postalCode}
                                    onChange={({ target: { value } }) => handleChange('postalCode', value, from)}
                                />
                                <p className="error">{from === 'shipping' ? shippingDetailError?.postalCode : invoiceDetailError?.postalCode}</p>
                            </div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const QuoteAddress = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ countryList, profile_account_information }, { get_country_list, get_state_list, get_profile_account_information }, { }] = profileStore();
    const [{ }, { }, { submit_quote }] = useQuoteStore();
    const [addressList, setAddressList] = useState({})
    const [shippingDetail, setShippingDetail] = useState(AddressDetails)
    const [invoiceDetail, setInvoiceDetail] = useState(AddressDetails)
    const [stateList, setStateList] = useState({
        shippingStateList: [],
        invoiceStateList: []
    })
    const [errors, setErrors] = useState({})
    const [attn, setAttn] = useState('')
    const [addressChange, setAddressChange] = useState({
        coreInvoiceAddress: addressList?.billTo?.find(billadd => billadd.default === true) || {},
        coreShippingAddress: addressList?.shipTo?.find(shipadd => shipadd.default === true) || {},
    })
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { siteUser: { WEB, CORE }, alphaNumericPatternWithSpace, countryCodes } = Constants
    const { avUserInfoData: { currentUser } } = System
    const isCoreUser = currentUser === CORE
    const isWebUser = currentUser === WEB
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(isCoreUser)

    useEffect(() => {
        async function fetchHere() {
            await get_country_list()
            if (isCoreUser) {
                await get_profile_account_information();
            }
        }
        fetchHere();
    }, [])

    useEffect(() => {
        if (isCoreUser) {
            setAddressList(profile_account_information)
            setAddressChange({
                coreInvoiceAddress: profile_account_information?.billTo?.find(billadd => billadd.default === true) || {},
                coreShippingAddress: profile_account_information?.shipTo?.find(shipadd => shipadd.default === true) || {},
            })
        }
    }, [profile_account_information])

    useEffect(() => {
      if(isCoreUser){
        const isCoreInvoiceAddressEmpty = Object.keys(addressChange?.coreInvoiceAddress || {}).length === 0;
        const isCoreShippingAddressEmpty = Object.keys(addressChange?.coreShippingAddress || {}).length === 0;
        if((!(isCoreInvoiceAddressEmpty)) && (!(isCoreShippingAddressEmpty))) {
          setIsSubmitButtonDisabled(false)
        } else {
          setIsSubmitButtonDisabled(true)
        }
      } else {
        setIsSubmitButtonDisabled(false)
      }  
    }, [addressChange])

    const renderStateListOnCountryChange = async (value, from) => {
        if (countryCodes.includes(value)) {
            const stateRes = await get_state_list(value)
            from === 'shipping' ? setStateList({ ...stateList, shippingStateList: stateRes }) : setStateList({ ...stateList, invoiceStateList: stateRes })
        }
    }

    const handleChange = (name, value, from) => {
        if (from === 'shipping') {
            if (Object.keys(errors)?.length > 0) {
                delete errors?.shippingDetailError[name]
            }
            name === 'country' ? setShippingDetail({ ...shippingDetail, state: '', [name]: value }) : setShippingDetail({ ...shippingDetail, [name]: value });
        } else {
            if (Object.keys(errors)?.length > 0 && from === 'invoice') {
                delete errors?.invoiceDetailError[name]
            }
            name === 'country' ? setInvoiceDetail({ ...invoiceDetail, state: '', [name]: value }) : setInvoiceDetail({ ...invoiceDetail, [name]: value });
        }
    }

    const onChecked = (checked) => {
        setInvoiceDetail(checked ? shippingDetail : AddressDetails)
        setStateList(checked ? { ...stateList, invoiceStateList: stateList.shippingStateList } : { ...stateList, invoiceStateList: [] })
        Object.keys(errors)?.length > 0 && setErrors({ ...errors, invoiceDetailError: errors?.shippingDetailError })
    }

    const validate = (details) => {
        let validations = {};
        Helper.valueIsNotNull(details?.companyName) || !Helper.validateRegex(details?.companyName, alphaNumericPatternWithSpace) ? "" : validations.companyName = "A valid name is required. Please do not include special characters";
        Helper.valueIsNotNull(details?.addressLineOne) ? "" : validations.addressLineOne = "A valid address is required";
        Helper.valueIsNotNull(details?.city) ? "" : validations.city = "A valid city is required to complete your profile";
        Helper.valueIsNotNull(details?.postalCode) ? "" : validations.postalCode = "A valid zip code is required";
        Helper.valueIsNotNull(details?.country) ? "" : validations.country = "Please select a country";
        if (!Helper.valueIsNotNull(details?.state) && countryCodes.includes(details?.country)) {
            validations.state = "Please select State/Province"
        }
        return validations
    }

    const onValidateData = () => {
        const shippingDetailError = validate(shippingDetail);
        const invoiceDetailError = validate(invoiceDetail);
        let validationModal = { ...shippingDetailError, ...invoiceDetailError }
        setErrors({ shippingDetailError, invoiceDetailError })
        return Object.keys(validationModal).length <= 0;
    }

    const onSubmit = async () => {
        if (isInternalUser) {
            system_alert_indicator({
                name: 'quoteAddressInternalUser',
                message: 'Error: Internal users are unable to submit quotations on behalf of the customer online. The quotation was not created',
                type: "danger"
            })
        } else {
            __set('QUOTE_API_CALL');
            let isValid = onValidateData();
            if (!isValid && isWebUser) {
                __remove('QUOTE_API_CALL');
                return;
            }
            let result = {}
            const { coreShippingAddress, coreInvoiceAddress } = addressChange
            let res = {
                shipToCompanyName: isCoreUser ? coreShippingAddress?.companyName : shippingDetail?.companyName,
                shipToAddress1stLine: isCoreUser ? coreShippingAddress?.address?.addressLineOne : shippingDetail?.addressLineOne,
                shipToAddress2ndLine: isCoreUser ? coreShippingAddress?.address?.addressLineTwo : shippingDetail?.addressLineTwo,
                shipToAddressCity: isCoreUser ? coreShippingAddress?.address?.cityName : shippingDetail?.city,
                shipToAddressCountryCode: isCoreUser ? coreShippingAddress?.address?.countryCode : shippingDetail?.country,
                shipToAddressState: isCoreUser ? coreShippingAddress?.address?.stateCode : shippingDetail?.state,
                shipToAddresszipCode: isCoreUser ? coreShippingAddress?.address?.postalCode : shippingDetail?.postalCode,
                soldToCompanyName: isCoreUser ? coreInvoiceAddress?.companyName : invoiceDetail?.companyName,
                soldToAddress1stLine: isCoreUser ? coreInvoiceAddress?.address?.addressLineOne : invoiceDetail?.addressLineOne,
                soldToAddress2ndLine: isCoreUser ? coreInvoiceAddress?.address?.addressLineTwo : invoiceDetail?.addressLineTwo,
                soldToAddressCity: isCoreUser ? coreInvoiceAddress?.address?.cityName : invoiceDetail?.city,
                soldToAddressCountryCode: isCoreUser ? coreInvoiceAddress?.address?.countryCode : invoiceDetail?.country,
                soldToAddressState: isCoreUser ? coreInvoiceAddress?.address?.stateCode : invoiceDetail?.state,
                soldToAddresszipCode: isCoreUser ? coreInvoiceAddress?.address?.postalCode : invoiceDetail?.postalCode,
                attn: attn
            }
            result = await submit_quote(res);
            __remove('QUOTE_API_CALL');

            if (result?.isSuccessFull) {
                System.popup('SubmitQuotePopup', { isSubmitted: false })
            } else if (result?.message) {
                setIsSubmitButtonDisabled(true)
                system_alert_indicator({
                    name: 'quoteAddressInternalUser',
                    message: result.message,
                    type: "danger"
                })
            } else {
                System.popup('SubmitQuotePopup', { isSubmitted: true })
            }
        }
    }

    return (
        <div id="main" className="">
            <ShowAlert />
            {ReusableDiv.QuoteHeader(System.getParams().__c)}
            <div id="pcnquote-submit-page" className="pcn-page container">
                <p>{isCoreUser ? 'We will need to know your shipping address.' : 'We will need to know some address details for your quote'}</p>
                <div className="content-box container quote-detail-form px-0 pt-0">
                    {isWebUser && <><h3 className='titleborder'>Fill in your shipping details</h3>
                        <span className="mb-2 d-block"></span></>}
                    <form>
                        {isCoreUser ? (
                            <>
                                <h3 className='titleborder'>Choose the address you wish to ship to</h3>
                                <div className='quote-address'>
                                    {addressList?.shipTo?.length > 0 && addressList?.shipTo.map((shipadd, index) => (
                                        <div key={index} className="radio">
                                            <input type="radio" value={shipadd.id} id={shipadd.id}
                                                checked={addressChange.coreShippingAddress?.id === shipadd.id}
                                                onChange={({ target: { value } }) => setAddressChange({ ...addressChange, coreShippingAddress: addressList?.shipTo.find(obj => obj.id === value) })}
                                            />
                                            <div className='mb-3'>
                                                <div className='companyname ps-0'>{shipadd.companyName}</div>
                                                <div
                                                    className='companyaddress'>{shipadd.address.addressLineOne}, <br/> {shipadd.address.addressLineTwo} <br /> {shipadd.address.cityName}, {shipadd.address.stateName} {shipadd.address.postalCode} <br /> {shipadd.address.countryName}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <h3 className='titleborder'>What will be your invoice address?</h3>
                                <div className='quote-address'>
                                    {addressList?.billTo?.length == 0 ?
                                      <p>Please add Invoice address in Address Book from Profile section.</p>
                                    :addressList?.billTo?.length > 0 && (
                                        addressList?.billTo.some(invoiceAdd => invoiceAdd.default) ?
                                            // If there is any address with default: true, show only those
                                            addressList?.billTo.map((invoiceAdd, index) => (
                                                (invoiceAdd.default || addressList?.billTo?.length === 1) && (
                                                    <div key={index} className="radio">
                                                        <input type="radio" value={invoiceAdd.id} id={invoiceAdd.id}
                                                            checked={addressChange.coreInvoiceAddress?.id === invoiceAdd.id}
                                                            onChange={({ target: { value } }) => setAddressChange({ ...addressChange, coreInvoiceAddress: addressList?.billTo.find(obj => obj.id === value) })}
                                                        />
                                                        <div className='mb-3'>
                                                            <div className='companyname ps-0'>{invoiceAdd.companyName}</div>
                                                            <div className='companyaddress'>
                                                                {invoiceAdd.address.addressLineOne}, <br/> {invoiceAdd.address.addressLineTwo}
                                                                <br /> {invoiceAdd.address.cityName}, {invoiceAdd.address.stateName} {invoiceAdd.address.postalCode}
                                                                <br /> {invoiceAdd.address.countryName}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            ))
                                            :
                                            // If no address has default: true, show all addresses
                                            addressList?.billTo.map((invoiceAdd, index) => (
                                                <div key={index} className="radio">
                                                    <input type="radio" value={invoiceAdd.id} id={invoiceAdd.id}
                                                        checked={addressChange.coreInvoiceAddress?.id === invoiceAdd.id}
                                                        onChange={({ target: { value } }) => setAddressChange({ ...addressChange, coreInvoiceAddress: addressList?.billTo.find(obj => obj.id === value) })}
                                                    />
                                                    <div className='mb-3'>
                                                        <div className='companyname ps-0'>{invoiceAdd.companyName}</div>
                                                        <div className='companyaddress'>
                                                            {invoiceAdd.address.addressLineOne}, <br/> {invoiceAdd.address.addressLineTwo}
                                                            <br /> {invoiceAdd.address.cityName}, {invoiceAdd.address.stateName} {invoiceAdd.address.postalCode}
                                                            <br /> {invoiceAdd.address.countryName}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )
                                    }

                                </div>
                            </>
                        ) : (
                            <>
                                <AddressForm countryList={countryList} from="shipping" handleChange={(name, value, from) => handleChange(name, value, from)} renderStateListOnCountryChange={renderStateListOnCountryChange} stateList={stateList} shippingDetail={shippingDetail} errors={errors} countriesHasData={countryCodes} />
                                <h3 className='titleborder'>Fill in your invoice details</h3>
                                <div className=" bs5 row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <div className="form-check mb-2">
                                                <input type="checkbox" className="form-check-input" id="checkbox" onChange={(e) => { onChecked(e.target.checked) }} />
                                                <label htmlFor="checkbox " className='d-inline-block'>Use Shipping Address As Invoice Address </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <AddressForm countryList={countryList} from="invoice" handleChange={(name, value, from) => handleChange(name, value, from)} renderStateListOnCountryChange={renderStateListOnCountryChange} stateList={stateList} invoiceDetail={invoiceDetail} errors={errors} countriesHasData={countryCodes} />
                            </>
                        )}
                        <h3 className='titleborder'>Specify An "Attention To" Name</h3>
                        <div className=" bs5 row">
                            <div className="col-3 mb-2">
                                <div className="form-group">
                                    <label htmlFor="attn" className='d-block'>ATTN (Optional)</label>
                                    <input type="text" className="form-control form-control-sm" id="attn" placeholder="ATTN (Optional)"
                                        onChange={(e) => setAttn(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="pcn-line-divider"></div>
                    <div className="d-flex justify-content-between align-items-center">
                        <a href={Quote.getQuoteRouteURL()}><i className="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                        <button className="bs5 btn btn-primary w150" data-toggle="modal" data-target="#submit-quote-Modal"
                            disabled={__check('QUOTE_API_CALL').status || isSubmitButtonDisabled} onClick={() => onSubmit()}>
                            {__check('QUOTE_API_CALL').status ? <i className="fa fa-spinner fa-spin" />: 'Submit Quote'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuoteAddress